import React from "react";
import { AnnotationMenuIconType, AnnotationMenuPropType } from "../AnnotationMenu";
import { AnnotationShapIcons } from "../helpers/AnnotationShapeIcons";

const AnnotationMenuShapes = (props: AnnotationMenuPropType) => {
  const display = () => {
    return AnnotationShapIcons.map((icon: AnnotationMenuIconType, index: number) => {
      return (
        <div
          id={icon.name}
          className={`annotation-icon`}
          key={index}
          onClick={(e: React.MouseEvent<HTMLDivElement>) => props.addNewAnnotation(e.currentTarget.id, "addShapeType")}
        >
          {icon.icon}
        </div>
      );
    });
  };

  return <React.Fragment>{display()}</React.Fragment>;
};

export default AnnotationMenuShapes;
